import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "count"]

  connect() {
    this.applyQuantum()
  }

  update() {
    this.applyQuantum()
  }

  applyQuantum() {
    const quantum = this.currentQuantum()
    if (!quantum || quantum <= 1) return

    const input = this.countTarget
    input.min = quantum
    input.step = quantum

    const current = parseInt(input.value) || 0
    if (current < quantum || current % quantum !== 0) {
      input.value = quantum
    }
  }

  currentQuantum() {
    if (this.hasSelectTarget) {
      const opt = this.selectTarget.selectedOptions[0]
      return parseInt(opt?.dataset?.quantum || 1)
    }
    return parseInt(this.element.dataset.cartQuantumQuantumValue || 1)
  }
}
